import { render, staticRenderFns } from "./SmtpMailDriver.vue?vue&type=template&id=e99b2ff2&"
import script from "./SmtpMailDriver.vue?vue&type=script&lang=js&"
export * from "./SmtpMailDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e99b2ff2')) {
      api.createRecord('e99b2ff2', component.options)
    } else {
      api.reload('e99b2ff2', component.options)
    }
    module.hot.accept("./SmtpMailDriver.vue?vue&type=template&id=e99b2ff2&", function () {
      api.rerender('e99b2ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/mail-driver/SmtpMailDriver.vue"
export default component.exports